<form *ngIf="block && form" [formGroup]="form">
  <pl-lifeact
    [title]="block.data.config.type"
    [subTitle]="block.data.config.heading"
    [description]="block.data.config.subBody"
    [calendarTitle]="block.data.config.calendarTitle"
    [calendarDescription]="block.data.config.calendarDescription"
    [formControlName]="FormControlName.lifeact"
    [isDisabled]="isDisabled"
    [timeFormat]="timeFormat"
  />
</form>
